import React from 'react';
import Badge, { Props } from '../badge/badge';

import defaultStyles from './unhighlighted-badge.scss';

export default (props: Omit<Props, 'styles'>) => <Badge style={{ badge: defaultStyles.badge }} {...props} />;
